import { Mutation, MutationTree } from "vuex";
import {
  BuffetMutation,
  BuffetState,
  PlayedEpgItemCoordinates
} from "@/components/buffet/types";
import { BuffetCategories } from "@/helpers/constants";

export const mutations: MutationTree<BuffetState> &
  Record<BuffetMutation, Mutation<BuffetState>> = {
  [BuffetMutation.setUpdatedBuffetItems](state, value: boolean) {
    state.updatedBuffetItems = value;
  },
  [BuffetMutation.setPlayedEpgItemPos](
    state,
    coordinates?: PlayedEpgItemCoordinates
  ) {
    if (!coordinates) {
      state.playedEpgItemPos = undefined;

      return;
    }

    state.playedEpgItemPos = coordinates;
  },
  [BuffetMutation.setPlayedEpgItemId](state, epgId?: number) {
    if (!epgId) {
      state.playedEpgItemId = undefined;

      return;
    }

    state.playedEpgItemId = epgId;
  },
  [BuffetMutation.setPlayedEpgItemCat](state, category?: BuffetCategories) {
    if (!category) {
      state.playedEpgItemCat = undefined;

      return;
    }

    state.playedEpgItemCat = category;
  },
  [BuffetMutation.setPlayedEpgItemDate](state, date?: string) {
    if (!date) {
      state.playedEpgItemCat = undefined;

      return;
    }

    state.playedEpgItemDate = date;
  }
};
